import { Component } from "@angular/core";

@Component({
	moduleId: module.id,
	selector: "footer",
	styleUrls: ["footer.css"],
	templateUrl: "footer.html"
})
export class FooterComponent {
}